import React from 'react'
import error404 from '../../assets/images/errorimg1.png'
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="maintenance-block">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card error-card">
                            <div className="card-body">
                                <div className="error-image-block">
                                    <img
                                        className="img-fluid"
                                        src={error404}
                                        style={{ height: "500px" }}
                                        alt="img"
                                    />
                                </div>
                                <div className="text-center mt-5">
                                    <p className="mt-2 mb-4 text-muted">
                                        The page you are looking was moved, removed,
                                        <br /> renamed, or might never exist!
                                    </p>
                                    <Link to="/login" className="btn btn-primary mb-3">
                                        Go to home
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound